/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	StudentCVAccessDTO,
	StudentCVAccessDTOFromJSON,
	StudentCVAccessDTOFromJSONTyped,
	StudentCVAccessDTOToJSON,
} from "./StudentCVAccessDTO";

/**
 *
 * @export
 * @interface StudentCVAccessDTOPagedResponse
 */
export interface StudentCVAccessDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof StudentCVAccessDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof StudentCVAccessDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof StudentCVAccessDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<StudentCVAccessDTO>}
	 * @memberof StudentCVAccessDTOPagedResponse
	 */
	data?: Array<StudentCVAccessDTO> | null;
}

export function StudentCVAccessDTOPagedResponseFromJSON(
	json: any
): StudentCVAccessDTOPagedResponse {
	return StudentCVAccessDTOPagedResponseFromJSONTyped(json, false);
}

export function StudentCVAccessDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): StudentCVAccessDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(StudentCVAccessDTOFromJSON),
	};
}

export function StudentCVAccessDTOPagedResponseToJSON(
	value?: StudentCVAccessDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(StudentCVAccessDTOToJSON),
	};
}
